module.exports = __webpack_public_path__ + "img/space1.8ddf86d2.jpg";